import { render, staticRenderFns } from "./LayoutReservation.vue?vue&type=template&id=95eb2088&scoped=true"
import script from "./LayoutReservation.vue?vue&type=script&lang=js"
export * from "./LayoutReservation.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./LayoutReservation.vue?vue&type=style&index=0&id=95eb2088&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "95eb2088",
  null
  ,true
)

export default component.exports